const initialBrandingState = {
  pageBackgroundImage: "",
  roomNameColor: "#443d80",
  buttonColor: "#1c2389",
  navbarColor: "#ffffff",
  footerColor: "#433d80",
  starRatingColor: "#f8c94a",
  dragBarColor: "#1c2389",
  navbarMenuColor: "#847aff",
  searchBarGradient:
    "linear-gradient(135deg, rgba(150, 95, 190, 0.645), rgba(78, 43, 87, 0.175))",
  headingColor: "#000000",
  paragraphColor: "#333333",
  priceTagColor: "#ff0000",
  headingFont:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

const initialGradientStart = {
  color: "#965fbe",
  opacity: 0.645,
};

const initialGradientEnd = {
  color: "#4e2b57",
  opacity: 0.175,
};

export { initialBrandingState, initialGradientStart, initialGradientEnd };
